import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/buyer/mall-route-setting-list',
      name: 'admin-buyer-mall-route-setting-list',
      component: () => import(/* webpackChunkName: "page-admin-buyer-management-mall-route-setting-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "B2B路线设置"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "分销商管理"
                                        },
                                        {
                                                  name: "分销商列表"
                                        },
                                        {
                                                  name: "B2B路线设置"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
